import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { FormGroup, Validators, FormControl } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { IPasswordResetRequest } from "../../interfaces/ipasswordresetrequest";
import { ResetPasswordService } from "../../services/resetpassword.service";
import { AuthService } from "../../services/auth.service";
import { AppSettings } from "../../appsettings";

import { IBusinessFunction } from "../../interfaces/ibusinessfunction";

@Component({
    selector: "passwordresetrequest",
    templateUrl: "./passwordresetrequest.component.html",
    standalone: false
})
export class PasswordResetRequestComponent implements OnInit, OnDestroy {
    businessFunction: IBusinessFunction | null = null;
    resettingPassword: boolean = false;
    resetPasswordFormGroup!: FormGroup;
    defaultRoute!: string;
    private destroy$ = new Subject<void>();

    constructor(private toastsManager: ToastrService,
        private resetPasswordService: ResetPasswordService,
        private router: Router,
        private activatedRoute: ActivatedRoute) { }

    ngOnInit(): void {
        this.resetPasswordFormGroup = new FormGroup({
            email: new FormControl("", [Validators.required, Validators.pattern(AppSettings.emailRegExp.source)])
        });
        this.activatedRoute.params
            .pipe(takeUntil(this.destroy$))
            .subscribe((p: Params) => {
                this.defaultRoute = p['defaultroute'];
                this.businessFunction = AuthService.getBusinessFunctionByDefaultRoute(this.defaultRoute);
            });
    }

    /**
     * Resets a password when clicked
     * @param form The form containing the values
     * @param formValid Whether or not the form is valid
     */
    resetPasswordClicked(form: IPasswordResetRequest, formValid: boolean): void {
        if (formValid) {
            this.resettingPassword = true;
            let bf: IBusinessFunction | null = AuthService.getBusinessFunctionByDefaultRoute(this.defaultRoute);
            if (!bf) return;
            this.resetPasswordService.resetPasswordRequest({ email: form.email, businessFunctionId: bf.id } as IPasswordResetRequest)
                .pipe(takeUntil(this.destroy$))
                .subscribe((res: boolean) => {
                    this.resettingPassword = false;
                    if (res) {
                        this.toastsManager.success(`An email has been sent to ${form.email}. Please follow the instructions provided.`);
                        this.router.navigate([`/${this.defaultRoute}/logon`]);
                    }
                }, () => { this.resettingPassword = false; });
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
